import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  failedRedirectButtonText: {
    defaultMessage: 'Return to {clientName}',
    id: 'SuccessOverlay.failedRedirectButtonText',
  },
  goBackToOrigin: {
    defaultMessage: 'You can now return to {clientName} app',
    id: 'CredentialsDirector.goBackToOrigin',
  },
  paymentId: {
    defaultMessage: 'Payment ID {paymentId}',
    id: 'SuccessOverlay.paymentId',
  },
});
